/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import {FluidContainer} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
//import {Teams} from '../../../utils/api';
import {TablesContainer, TablesWrapper} from './styles';
import {default as ArmSoreness} from './armSoreness/armSoreness';
import {default as Fatigue} from './fatigue/fatigue';
import {default as Workloads} from './scorecardWorkloads/workloads';
import {default as TrainingAccountability} from './trainingAccountability/trainingAccountability';
import {default as ExamAccountability} from './examAccountability/examsAccountability';
import {default as PersonalRecords} from './personalRecords/personalRecords';
import {default as MedicalAlerts} from './medicalAlerts/medicalAlerts';

export default () => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const {selectedPlayer} = useContext(ARMcontext);

  //const TEAMS = new Teams();

  useEffect(() => {
    getIndividualScorecardData();
  }, [selectedPlayer]);
  async function getIndividualScorecardData() {
    //const examsResponse = await TEAMS.GetScorecardFromPlayer(selectedPlayer?._id);
    const examsResponse: any = {
      status: true,
      data: {
        records: [
          {
            fatigue: {alert: 'Warning', test: 'ir rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'back'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Medical', test: 'er strength', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'shoulder'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Watch', test: 'er rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {location: 'eg'},
            workloads: {date: null, latestAcRatio: 0.5},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Warning', test: 'ir rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'back'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Medical', test: 'er strength', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'shoulder'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Watch', test: 'er rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {location: 'eg'},
            workloads: {date: null, latestAcRatio: 0.5},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Warning', test: 'ir rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'back'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Medical', test: 'er strength', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {level: '1', location: 'shoulder'},
            workloads: {date: null, latestAcRatio: 'float'},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
          {
            fatigue: {alert: 'Watch', test: 'er rom', infoFatigue: ''},
            medicalAlerts: {lastFreshExamDay: 'isodate', reason: 'string'},
            armSoreness: {location: 'eg'},
            workloads: {date: null, latestAcRatio: 0.5},
            trainingAccountability: {lastTrainingDay: 'isodate', last7Days: 'float'},
            examAccountability: {lastFreshExams: 'isoDate', daysWithoutExams: 'int'},
            personalRecords: {date: 'isodate', category: 'string', situation: 'string', result: 'string'},
          },
        ],
      },
    };
    if (examsResponse.status) {
      useExams(examsResponse.data.records);
    }
  }
  return (
    <FluidContainer overflow={false}>
      <TablesWrapper>
        <TablesContainer>
          <ArmSoreness dataTableContent={exams} dataCy="arm-soreness-player" />
          <Fatigue dataTableContent={exams} />
          <Workloads dataTableContent={exams} />
          <TrainingAccountability dataTableContent={exams} />
          <ExamAccountability dataTableContent={exams} />
          <PersonalRecords dataTableContent={exams} />
          <MedicalAlerts dataTableContent={exams} />
        </TablesContainer>
      </TablesWrapper>
    </FluidContainer>
  );
};
